import { z } from 'zod'
export const removeCollaboratorSchema = z.object({
  jobId: z.string().uuid(),
  collaboratorId: z.string(),
  isPendingCollaborator: z.boolean(),
})
export type RemoveCollaborator = z.infer<typeof removeCollaboratorSchema>
